import script from "./flightParticipants.vue?vue&type=script&setup=true&lang=ts"
export * from "./flightParticipants.vue?vue&type=script&setup=true&lang=ts"

import "./flightParticipants.vue?vue&type=style&index=0&id=226d6c6c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226d6c6c"]])

export default __exports__